import { Injectable, signal } from '@angular/core';

// Use this service to manage visibility/other states of the menubar's controls
@Injectable({
  providedIn: 'root',
})
export class MenuControlsService {
  #isDisplayCurrentStoreAndRegister = signal(false);
  #isDisplayManageRegisterButton = signal(false);
  #isDisplayBackToPosButton = signal(false);
  #isDisplayTransactionControls = signal(false);

  isDisplayCurrentStoreAndRegister =
    this.#isDisplayCurrentStoreAndRegister.asReadonly();
  isDisplayManageRegisterButton =
    this.#isDisplayManageRegisterButton.asReadonly();
  isDisplayBackToPosButton = this.#isDisplayBackToPosButton.asReadonly();
  isDisplayTransactionControls =
    this.#isDisplayTransactionControls.asReadonly();

  setDisplayCurrentStoreAndRegister(value: boolean): void {
    this.#isDisplayCurrentStoreAndRegister.set(value);
  }

  setDisplayManageRegisterButton(value: boolean): void {
    this.#isDisplayManageRegisterButton.set(value);
  }

  setDisplayBackToPosButton(value: boolean): void {
    this.#isDisplayBackToPosButton.set(value);
  }
  setDisplayTransactionControls(value: boolean): void {
    this.#isDisplayTransactionControls.set(value);
  }
}
